import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#fha-loan-app', App);
